<script>
import {useDeviceManufacturersStore} from "@/stores/deviceManufacturers.js";
import {mapStores} from "pinia";
import FilterCheckbox from "@/Forms/Filters/FilterCheckbox.vue";

export default {
  name: "FilterDeviceManufacturersTab",
  inheritAttrs: false,
  components: {FilterCheckbox},
  computed: {
    ...mapStores(useDeviceManufacturersStore),
  },
  mounted() {
    console.log(this.$options.name);
    this.deviceManufacturersStore.indexDeviceManufacturerOptions();
  },
}
</script>

<template>
  <p class="font-bold text-xl mb-4">Device Manufacturers</p>
  <div class="card flex flex-wrap justify-content-center gap-3">
    <FilterCheckbox
        v-for="deviceManufacturer in deviceManufacturersStore.getDeviceManufacturerOptions"
        v-bind="$attrs"
        :value="deviceManufacturer.id"
        :label="deviceManufacturer.name"
    />
  </div>
</template>

<style scoped>

</style>